import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/Both/HomeView.vue'
import LoginView from "@/views/User/LoginView.vue";
import LayoutView from "@/views/Layout.vue";
import HomeLayout from "@/views/HomeLayout.vue";
import RegisterView from "@/views/User/RegisterView.vue";
import CenterView from "@/views/Both/CenterView.vue";
import PublishView from "@/views/Both/PublishView.vue";
import PersonalView from "@/views/Both/PersonalView.vue";
import RechargeView from "@/views/Both/RechargeView.vue";
import RechargePackageView from "@/views/Both/RechargePackageView.vue";


Vue.use(VueRouter)

const routes = [
  // 首页使用独立布局（无侧边栏）
  {
    path: '/',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView,
        meta: { title: '首页', hideAside: true }
      }
    ]
  },
  // 发布页面使用首页布局（无侧边栏）
  {
    path: '/publish',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'Publish',
        component: PublishView,
        meta: { title: '发布信息' }
      }
    ]
  },
  // 个人中心相关页面也使用首页布局（无侧边栏）
  {
    path: '/center',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'Center',
        component: CenterView,
        meta: { title: '个人中心' }
      }
    ]
  },
  {
    path: '/personal',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'Personal',
        component: PersonalView,
        meta: { title: '个人资料' }
      }
    ]
  },
  {
    path: '/recharge',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'Recharge',
        component: RechargeView,
        meta: { title: '充值支付' }
      }
    ]
  },
  {
    path: '/recharge-package',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'RechargePackage',
        component: RechargePackageView,
        meta: { title: '充值中心' }
      }
    ]
  },
  // 我的下载
  {
    path: '/my-download',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'MyDownload',
        component: () => import('@/views/Both/MyDownloadView.vue'),
        meta: { title: '我的下载' }
      }
    ]
  },
  // 供需相关页面也使用首页布局
  {
    path: '/supply-demand',
    component: HomeLayout,
    children: [
      {
        path: 'list',
        name: 'SupplyDemandList',
        component: () => import('@/views/SupplyDemand/SupplyDemandListView.vue'),
        meta: { title: '供需列表' }
      },
      {
        path: 'detail/:id',
        name: 'SupplyDemandDetail',
        component: () => import('@/views/SupplyDemand/SupplyDemandDetailView.vue'),
        meta: { title: '供需详情' }
      },
      {
        path: 'my',
        name: 'MySupplyDemand',
        component: () => import('@/views/SupplyDemand/MySupplyDemandView.vue'),
        meta: { title: '我的供需' }
      }
    ]
  },
  // 其他功能页面使用首页布局
  {
    path: '/favorite',
    component: HomeLayout,
    children: [
      {
        path: 'list',
        name: 'FavoriteList',
        component: () => import('@/views/Favorite/FavoriteListView.vue'),
        meta: { title: '我的收藏' }
      }
    ]
  },
  {
    path: '/hot',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'Hot',
        component: () => import('@/views/Hot/HotSupplyDemandView.vue'),
        meta: { title: '热门推荐' }
      }
    ]
  },
  {
    path: '/clue',
    component: HomeLayout,
    children: [
      {
        path: 'list',
        name: 'ClueList',
        component: () => import('@/views/Clue/ClueListView.vue'),
        meta: { title: '供需线索' }
      },
{
    path: 'detail/:id',
    name: 'ClueDetail',
    component: () => import('@/views/Clue/ClueDetailView.vue'),
    meta: { title: '线索详情' }
  },
      {
        path: 'khh/detail',
        name: 'KhhDetail',
        component: () => import('@/views/Clue/KhhDetailView.vue'),
        meta: { title: '开户行详情' }
      },
      {
        path: 'cw/detail',
        name: 'CwDetail',
        component: () => import('@/views/Clue/CwDetailView.vue'),
        meta: { title: '财务详情' }
      }
    ]
  },
  // 企业数据包
  {
    path: '/data-package',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'DataPackage',
        component: () => import('@/views/DataPackage/DataPackageView.vue'),
        meta: { title: '企业数据包' }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { title: '用户登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { title: '用户注册' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 解决Vue Router重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

//路由守卫
router.beforeEach((to, from, next) => {
  // 动态设置浏览器标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 供需信息平台`;
  } else {
    document.title = '供需信息平台';
  }
  
  const user = localStorage.getItem('user');
  
  // 白名单：不需要登录就能访问的页面
  const whiteList = ['/login', '/register'];
  
  if (!user && !whiteList.includes(to.path)) {
    // 未登录且不在白名单中，跳转到登录页
    // 提示登录失效
    // this.$message("登录失效，请重新登录！");
    return next('/login');
  }
  
  next();
})

export default router
